import React, { useContext } from 'react';
import { Redirect, Route, Switch as ReactRouterSwitch } from 'react-router';
import { useCurrentAliceApp } from 'client/hooks/useCurrentAliceApp';
import { routes } from 'client/lib/routes';
import Settings from 'client/blocks/Settings/Settings';
import { getInstallableAppSettingsEntity } from 'client/utils';
import { SettingsPageContext } from 'client/context/settingsPageContext';
import { InstallableApp } from 'client/model/skill';

export const InstallableAppSettingsPage = () => {
    const { hasUnsavedChanges, setHasUnsavedChanges } = useContext(SettingsPageContext);
    const installableApp = useCurrentAliceApp()! as InstallableApp;

    return (
        <div>
            <article>
                <ReactRouterSwitch>
                    <Route
                        path={routes.app.installableAppSettings(
                            installableApp.channel,
                            true,
                            'main',
                            installableApp.id,
                        )}
                    >
                        <Settings
                            aliceApp={installableApp}
                            isDraft={true}
                            registerChanges={setHasUnsavedChanges || ((_) => {})}
                            hasChanges={!!hasUnsavedChanges}
                            settings={getInstallableAppSettingsEntity(installableApp, true)}
                        />
                    </Route>
                    <Route
                        path={routes.app.installableAppSettings(
                            installableApp.channel,
                            false,
                            'main',
                            installableApp.id,
                        )}
                    >
                        {installableApp.onAir ? (
                            <Settings
                                aliceApp={installableApp}
                                isDraft={false}
                                registerChanges={setHasUnsavedChanges || ((_) => {})}
                                hasChanges={!!hasUnsavedChanges}
                                settings={getInstallableAppSettingsEntity(installableApp, false)}
                            />
                        ) : (
                            <Redirect
                                to={routes.app.installableAppSettings(
                                    installableApp.channel,
                                    true,
                                    'main',
                                    installableApp.id,
                                )}
                            />
                        )}
                    </Route>
                    <Redirect
                        exact
                        from={routes.app.installableAppPage(
                            installableApp.channel,
                            false,
                            'settings',
                            installableApp.id,
                        )}
                        to={routes.app.installableAppSettings(installableApp.channel, false, 'main', installableApp.id)}
                    />
                    <Redirect
                        exact
                        from={routes.app.installableAppPage(
                            installableApp.channel,
                            true,
                            'settings',
                            installableApp.id,
                        )}
                        to={routes.app.installableAppSettings(installableApp.channel, true, 'main', installableApp.id)}
                    />
                </ReactRouterSwitch>
            </article>
        </div>
    );
};
